module.exports = __webpack_public_path__ + "assets/img/jindu_cover.4c3723d0.png";